import React, { useCallback } from "react";
import { Image } from "./common";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const dynamicHeaderNavigate = useCallback(
    (pathName) => {
      return pathName.split("/")[1].split("_").join(" ");
    },
    [location?.pathname]
  );

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div
      className="bg-header-color p-2"
      style={{ position: "sticky", top: 0, zIndex: 2 }}
    >
      <div className=" container-fluid d-flex justify-content-between align-items-center">
        <div className="text-white fw-bold fs-4">
          {!["/dashboard"].includes(location?.pathname?.toLowerCase()) && (
            <span style={{ marginRight: "6px" }}>
              <IoMdArrowRoundBack onClick={goBack} />
            </span>
          )}
          {dynamicHeaderNavigate(location.pathname)}
        </div>
        <Image
          src="https://www.itdoseinfo.com/assets/img/logo/logo-itdose.png"
          className="header-logo"
        />
      </div>
    </div>
  );
}

export default Header;
